export const formatModerationTime = value => {
  const date = typeof value === 'string' ? new Date(value) : null;
  return date && Number.isFinite(date.getTime()) ? date.toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai', hourCycle: 'h23' }) : '';
};

export const accountStatusMessage = data => {
  const until = formatModerationTime(data?.banned_until);
  const messages = {
    invalid_credentials: '用户名或密码错误',
    account_frozen: '账号已被冻结，请联系管理员解冻',
    account_suspended: until ? `账号暂时封禁，请在 ${until}（北京时间）后重新登录` : '账号暂时封禁，请在封禁到期后重新登录',
    account_permanently_banned: '账号因多次违规已被永久封禁',
    account_unavailable: '账号已不可用，请联系管理员',
    account_state_changed: '账号安全状态已变更，请重新登录',
  };
  return Object.prototype.hasOwnProperty.call(messages, data?.code) ? messages[data.code] : '';
};

// 只保存本人接口中的只读处罚信息，不将登录令牌或其他响应字段写入 Redux。
export const normalizeAccountModeration = value => {
  if (!value || typeof value !== 'object' || !Number.isSafeInteger(value.violation_count) || value.violation_count < 0) return null;
  return {
    violation_count: value.violation_count,
    banned_until: formatModerationTime(value.banned_until) ? value.banned_until : null,
    permanently_banned: value.permanently_banned === true,
    last_penalty_at: formatModerationTime(value.last_penalty_at) ? value.last_penalty_at : null,
    notice: typeof value.notice === 'string' ? value.notice.trim() : null,
  };
};

export const accountModerationState = (value, now = Date.now()) => {
  const data = normalizeAccountModeration(value);
  if (!data) return null;
  if (data.permanently_banned) return { label: '永久封禁', color: 'purple', activeBan: true };
  if (data.banned_until && Date.parse(data.banned_until) > now) return { label: '封禁中', color: 'error', activeBan: true };
  if (data.banned_until) return { label: '处罚已到期', color: 'cyan', activeBan: false };
  return data.violation_count ? { label: '已警告', color: 'warning', activeBan: false } : null;
};

export const reportPenaltyLabels = { warning: '警告', temporary: '限时封禁', permanent: '永久封禁' };
export const reportPenaltyColors = { warning: 'warning', temporary: 'error', permanent: 'purple' };
